var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBasicProcessor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 13 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.837 5.457v6.549H1.077V5.456L4.841 3.82V4.91l2.69-1.091v1.637zM9.254 4.64l.43-3.548H11.3l.43 3.548zM5.92 9.823h1.076V7.64H5.919zm-2.153 0h1.076V7.64H3.766zm5.38-2.183H8.072v2.183h1.076z"
})));
export { SvgBasicProcessor as ReactComponent };
export default __webpack_public_path__ + "static/media/BasicProcessor.a6f643f7.svg";